import { useStoreState } from 'easy-peasy'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { useHasSuperCard } from 'hooks/supercard_hooks'

export default function Container({ children }) {
  const hasSuperCard = useHasSuperCard()
  const router = useRouter()
  const state = useStoreState(s => ({ me: s.me, cartItems: s.cartItems, scCardsV2: s.scCardsV2 }))

  const [loading, setLoading] = useState(false)

  const handleKnowMore = () => {
    const redirectRoute = state.me.payload.details && !hasSuperCard ? '/supercard/buy' : '/catalog/categories/supercard-exclusives'
    router.push(redirectRoute)
  }

  useEffect(() => {
    const isStateNotReady = state.me.status === 1 && state.cartItems.status === 1

    setLoading(isStateNotReady)
  }, [state.me, state.cartItems])

  return children({ handleKnowMore, loading })
}
